
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
//引入自定义卡片组件
// import CommodsCard from "@/views/commodity/template/CommodsCard.vue";
import commdsClass from "@/views/goodsManage/commodity/subPage/commdsClass.vue"
import GoodsCategorySelect from '@/views/goodsManage/commodity/template/GoodsCategorySelect.vue'
import { Getter } from "vuex-class";
import {
  GoodsListDto,
  getGoodsList,
  batchDisableGoods,
  batchUpGoods,
  batchDeleteGoods,
  batchDownGoods,
  deleteGoods,
  BatchRecommendGoods
} from "@/api/commodity";
import { downloadUrl, handleFill } from '@/utils/util';
import { categoryDto } from '@/api/goods';
import { confirm } from '@/utils/decorator';


@Component({
  components: { commdsClass, GoodsCategorySelect }
})
export default class commodity extends Vue {
  @Prop({ default: false }) checkshow?: boolean
  @Prop({ default: false }) isKeyword?: boolean
  @Prop({ default: () => [] }) checkList?: { goodsId?: string }[]
  @Getter goodsId!: string
  @Getter companyId: string
  @Getter providerId!: string
  downloadUrl = downloadUrl
  handleFill = handleFill
  goodsStatus = ''

  //没有数据  目前所有的companyID、goodsId全部写死
  params = {
    goodsStatus: '1',
    pageIndex: 1,
    pageSize: 10,
    isPage: true,
    keyword: '',
    hierarchyId: ''
  }
  goodsList: GoodsListDto[] = []
  checkResult: { goodsId?: string }[] = []
  refreshing = false

  // 更多下拉操作选择
  popoverActions = [
    { text: '设为推荐商品', iconType: 'icon-icon_tuijian',action:'recommend' },
    { text: '上架', iconType: 'icon-icon_shangjia',action:'UpGoods' },
    { text: '下架', iconType: 'icon-icon_xiajia',action:'DownGoods' },
    { text: '停用', iconType: 'icon-icon_tingyong',action:'DisableGoods' },
    { text: '删除', iconType: 'icon-icon_shanchu',action:'DeleteGoods' },
  ]

  @Watch('checkList')
  oncheckList () {
    this.checkResult = this.checkList
  }

  @Watch('checkResult')
  oncheckResult () {
    this.$emit('update:checkList', this.checkResult)
  }

  filterKeyword (keyword: string) {
    this.params.pageIndex = 1
    this.params.keyword = keyword
    this.params.goodsStatus = ''
    this.goodsList = []
    this.getList()
  }

  created () {
    if (this.isKeyword) return false
    this.getList()
  }
  //搜索
  toSearchHistory () {
    this.$router.push({
      path: '/searchCommodity',
      query: {
        searchType: '3'
      }
    })
  }
  onLoad () {
    this.params.pageIndex = this.params.pageIndex + 1
    this.getList()
  }
  loading = false
  finished = false
  getList (params = {}) {
    this.params = { ...this.params, ...params }
    this.loading = true
    getGoodsList(this.params).then((res) => {
      //展示数据列表集合
      if (this.params.pageIndex === 1) {
        this.goodsList = res.data.records || []
        this.finished = false
      } else {
        this.goodsList = this.goodsList.concat(res.data.records || [])
      }
      this.goodsList = this.goodsList.map(item => {
        return {
          ...item,
          showMark: false // 控制更多下拉操作选择
        }
      })
      if (this.params.pageIndex >= res.data.totalPages) {
        this.finished = true
      }
      this.$emit('totalRecords', res.data.totalRecords)
    }).finally(() => {
      this.loading = false
      this.refreshing = false
    })
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getList()
  }
  handleCheck () {

  }


  //获取上架列表和数量
  getsjList () {
    this.params.goodsStatus = '1'
    this.params.pageIndex = 1
    this.getList()
  }
  //获取下架列表和数量
  getxjList () {
    this.params.goodsStatus = '2'
    this.params.pageIndex = 1
    this.getList()
  }

  //获取停用列表和数量
  gettyList () {
    this.params.goodsStatus = '3'
    this.params.pageIndex = 1
    this.getList()
  }

  activeState = 0
  // 上架
  showUp () {
    this.activeState = 0
    this.getsjList()
  }
  // 下架
  showDown () {
    this.activeState = 1
    this.getxjList()
  }
  // 停用
  showStop () {
    this.activeState = 2
    this.gettyList()
  }
  //商品分类
  showRules () {
    (this.$refs.goodsCategorySelect as GoodsCategorySelect).showModal()
  }
  /**
   * 商品分类回调
   */
  handleSelectCategory (data: categoryDto) {
    this.params.hierarchyId = data.categoryId
    this.params.pageIndex = 1
    this.getList()
    this.clearData()
  }
  getGoodsIdListParam () {
    return this.checkResult.map(item => {
      return {
        goodsId: item
      }
    })
  }
  clearData () {
    this.checkResult = []
  }

  /**
   * 设为推荐商品
   */
  @confirm('温馨提示', '确定设为推荐商品？')
  handleBatchRecommendGoods (goodsIdList, ignoreDeleteTip = false) {
    if (!this.$isAction('recommend')) {
      return false
    }
    let params = {
      ignoreDeleteTip,
      goodsIdList
    }
    BatchRecommendGoods(params).then(res => {
      if (res.data.isNeedConfirm) {
        this.batchRecommendGoodsConfirm(goodsIdList)
      } else {
        this.$notify({
          type: 'success',
          message: '设置成功'
        })
        this.params.pageIndex = 1
        this.getList()
        this.clearData()
      }
    })
  }
  @confirm('温馨提示', '本次修改将删除推荐商品列表中的部分数据，是否确认修改？')
  batchRecommendGoodsConfirm (goodsIdList) {
    this.handleBatchRecommendGoods(goodsIdList, true)
  }

  /**
   * 上架
   */
  @confirm('温馨提示', '确定上架？')
  upGoods (goodsIdList) {
    if (!this.$isAction('UpGoods')) {
      return false
    }
    let params = { goodsIdList }
    batchUpGoods(params).then((res) => {
      this.$notify({
        type: 'success',
        message: '上架成功'
      })
      this.params.pageIndex = 1
      this.getList()
      this.clearData()
    })
  }

  /**
   * 下架
   */
  @confirm('温馨提示', '确定下架？')
  downGoods (goodsIdList) {
    if (!this.$isAction('DownGoods')) {
      return false
    }
    let params = { goodsIdList }
    batchDownGoods(params).then((res) => {
      this.$notify({
        type: 'success',
        message: '下架成功'
      })
      this.params.pageIndex = 1
      this.getList()
      this.clearData()
    })
  }
  /**
   * 停用
   */
  @confirm('温馨提示', '确定停用？')
  disableGoods (goodsIdList) {
    if (!this.$isAction('DisableGoods')) {
      return false
    }
    let params = { goodsIdList }
    batchDisableGoods(params).then(() => {
      this.$notify({
        type: 'success',
        message: '停用成功'
      })
      this.params.pageIndex = 1
      this.getList()
      this.clearData()
    })
  }

  /**
   * 删除
   */
  @confirm('温馨提示', '确定删除？')
  deleteGoods (goodsIdList) {
    if (!this.$isAction('DeleteGoods')) {
      return false
    }
    let params = { goodsIdList }
    batchDeleteGoods(params).then(() => {
      this.$notify({
        type: 'success',
        message: '删除成功'
      })
      this.params.pageIndex = 1
      this.getList()
      this.clearData()
    })
  }

  /**
   * 进入详情页
   * @param e
   * @param id 关联id
   * @param goodsId 商品编号
   */
  toDetail (e: string, id: string, goodsId: string,upRighNow:string) {
    if (!this.$isAction('commodsDetail')) {
      return false
    }
    this.$router.replace({
      path: '/commodsDetail',
      query: {
        relationId: id,
        goodsId: goodsId,
        upRighNow
      }
    })

  }
  /**
   * 进入商品编辑页
   */
  editGoodsPage (goodsId: string, op: string,upRighNow:string) {
    // if(op==='copy'&&!this.$isAction('copyGoods')){
    //   this.$toast('暂无此操作权限，请联系管理员')
    //   return false
    // }
    // if(op==='edit'&&!this.$isAction('editGoods')){
    //   this.$toast('暂无此操作权限，请联系管理员')
    //   return false
    // }
    this.$router.push({
      path: '/addCommodity',
      query: {
        goodsId,
        op,
        upRighNow
      }
    })
  }


  /**
   * @description: 更多事件监听
   * @param {*}
   * @return {*}
   */
  onGoodsMoreTap (index: number) {
    // 手风琴模式
    this.goodsList.filter((item, filterIndex) => {
      return item.showMark && index != filterIndex
    }).forEach(item => item.showMark = false)
    this.goodsList[index].showMark = !this.goodsList[index].showMark
  }

  /**
   * @description: 更多下拉选项事件监听
   * @param {*} index 索引(0: 设为推荐商品，1：上架，2：下架，3：停用，4：删除)
   * @param {*} goodsId 商品id
   * @return {*}
   */
  onGoodsMoreItemTap (index: number, goodsId: string,action:string) {
    if (!this.$isAction(action)) {
      this.$toast('暂无此操作权限，请联系管理员')
      return false
    }
    let goodsIdList = [{ goodsId }]
    switch (index) {
      // 设为推荐商品
      case 0:
        this.handleBatchRecommendGoods(goodsIdList)
        break
      // 上架
      case 1:
        this.upGoods(goodsIdList)
        break
      // 下架
      case 2:
        this.downGoods(goodsIdList)
        break
      // 停用
      case 3:
        this.disableGoods(goodsIdList)
        break
      // 删除
      case 4:
        this.deleteGoods(goodsIdList)
        break
    }
  }

}
